import React, { useState, useEffect, useRef} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import "../assets/css/styles.table.css"
import Sidebar from './Sidebar';
import Header from './Header';
import '../App.css';
import AxiosFetchData from './AxiosFetchData.js'
import { getComponent } from '@syncfusion/ej2-base';
import Box from '@mui/material/Box';
import { Typography, Modal
} from '@mui/material';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import { useTheme } from '@mui/material/styles';
// import Button from '@mui/material/Button';
//for table
import { TreeViewComponent, ContextMenuComponent  } from '@syncfusion/ej2-react-navigations';

const ProjectList =   () => {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [confirmDeleteOpen,setConfirmDeleteOpen] = useState(false);
    const [name, setName] = useState([]);
    // const [open, setOpen] = React.useState(false);
    // const theme = useTheme();
    // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    let dialogInstance;
     
    let menuObj;
    let treeObj;

    
    useEffect(  () => {
          GetTreeView();
    //   alert('aaa')
      }, []);

    const GetTreeView = async () => {
        const response = await AxiosFetchData.get(`GetTreeView/${id}`).refreshToken();
        setRows(response.data);
    }

    async function editing(args) {
       args.project_id = id;
       const response = await AxiosFetchData.post("UpdateTextNode",args).refreshToken();
        await GetTreeView();
    
    }

    async function dragdrop(args) {
       // console.log(args)
        var data ={
            parent_id : args.dropTarget.outerHTML.split("data-uid")[1].replace("=","").split(" ")[0].replace(/"/g,""),
            id : args.draggedNodeData.id,
            position : args.position,
            id_old :args.droppedNodeData.id
        }

        const response = await AxiosFetchData.post("UpdateParentId", data).refreshToken();
     }

    
     async function nodeclicked(args) {
        if (args.event.which === 3) {
            treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
        }
        
       // dialogInstance.show(true);
    }
    //Render the context menu with target as Treeview
    let menuItems = [
        { text: 'Add New Task' },
         { text: 'Remove Task' }
    ];

    let index = 1;
    async function menuclick(args) {
        let targetNodeId = treeObj.selectedNodes[0];
        if (args.item.text == "Add New Task") {
            //insert & ambil id nya masukan ke nodeId
            let nodeId = "tree_" + index;
            let item = { id: nodeId, name: "New Folder" };
            treeObj.addNodes([item], targetNodeId, null);
            index++;
            rows.push(item);
            treeObj.beginEdit(nodeId);
            //console.log(args)
        }
        else if (args.item.text == "Remove Task") {
            treeObj.removeNodes([targetNodeId]);
             await AxiosFetchData.delete(`RemoveNode/${targetNodeId}`).refreshToken();
            //----
        }
        
    }
    async function beforeopen(args) {
        let targetNodeId = treeObj.selectedNodes[0];
        let targetNode = document.querySelector('[data-uid="' + targetNodeId + '"]');
        if (targetNode.classList.contains('remove')) {
            menuObj.enableItems(['Remove Task'], false);
        }
        else {
            menuObj.enableItems(['Remove Task'], true);
        }
       // console.log(args)
    }
 

    async function collapse(args) {
        var data = {
            tipe: 0,
            id : args.nodeData.id
        }
        await AxiosFetchData.post(`SetExpandNode`, data).refreshToken();
    }

    async function expanded(args) {
        var data = {
            tipe: 1,
            id : args.nodeData.id
        }
        await AxiosFetchData.post(`SetExpandNode`, data).refreshToken();
    }
   
    function nodeTemplate(data) {
        //console.log(data);
       // alert('aaa')
        return (<div style={{display:'flex', width:"100%", border:1,borderColor:'black'}}>
                    <div>{data.name}</div>
                    <div style={{textAlign:"right"}}><button style={{height:30, border:0,marginLeft:10, backgroundColor:'white'}}  onClick={() => handleClickOpen(data.id)}>...</button></div>
                </div>);
    }

    function handleClickOpen(id){
        //alert(id);
        dialogInstance.show(true);
    //setConfirmDeleteOpen(true)
   //  setStatus({ hideDialog: true });
       //  setName(id)
       console.log(dialogInstance)
        //dialogInstance.html("Aaa")
        document.getElementById('sample').innerHTML = id
      //console.log(dialogInstance)
       
    }

    let index2 = 100;
    function AddTree(){
        let targetNodeId = treeObj.selectedNodes[0];
        let nodeId = "tree_" + index2 
        let item = { id: nodeId, name: "New Folder" };
        treeObj.addNodes([item], targetNodeId, null);
        index++;
        rows.push(item);
        treeObj.beginEdit(nodeId);
    }

    const fields = { dataSource: rows, id: 'id', text: 'name', child: 'subChild', seq : 'seq' };
    return (
        <body className="skin-blue">
            <div className="wrapper">

     <Sidebar />


<div className="content-wrapper">
<Header/>
   
  <div className='pd_headline'><b>Task List</b> </div>
 
  <div className="pd"  id='dialog-target'>
    
            <div style={{marginLeft:30, marginTop:10}}><button onClick={() => AddTree()} className='btn btn-primary' style={{width:120}}>ADD PROJECT</button></div>
        
            <div id='tree'>
                <TreeViewComponent fields={fields} allowEditing={true} nodeEdited={editing.bind(this)} allowDragAndDrop={true} nodeDropped={dragdrop.bind(this)} ref={(treeview) => { treeObj = treeview; }} nodeClicked={nodeclicked.bind(this)} nodeCollapsed={collapse.bind(this)} nodeExpanded={expanded.bind(this)} nodeTemplate={nodeTemplate} />
                <ContextMenuComponent id="contentmenutree" target='#tree' items={menuItems} beforeOpen={beforeopen.bind(this)} select={menuclick.bind(this)} ref={(contextmenu) => { menuObj = contextmenu; }}/>
            </div>
            
            <div className='App2' id="aaa" >

</div>
<DialogComponent
                showCloseIcon={true}
                visible={false}
                id="sample" 
               width='150px'
           
                target=".wrapper"
     // buttons={this.buttons}
                ref={(dialog) => (dialogInstance = dialog)}
               
            >
             <div id="divName"></div>
            </DialogComponent>
        
    </div>

  </div>


 
</div>

</body>

       
    );
}
 

export default ProjectList;